import React, { useEffect, useMemo, useState } from "react";

import Service from "src/organization/pages/project/environment/metrics/containers/Service";
import { ServiceUnitProps } from "src/organization/pages/project/environment/metrics/containers/Service/type";
import { usePollgroupContext } from "src/organization/pages/project/environment/metrics/utils/polling/usePollgroup";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

import InstanceSelector from "./InstanceSelector";
import usePoll from "./usePoll";

export type GridServiceProps = {
  setLastUpdated: (date: Date) => void;
  isOnviewport?: boolean;
} & ServiceUnitProps;

const fetchMetrics = (client, timeframe, service) =>
  client.getResourcesByService({
    timeframe,
    service
  });

const GridService = (props: GridServiceProps) => {
  const [instanceHost, setInstanceHost] = useState<string[]>();
  const [isLoading, setIsLoading] = useState(true);
  const { pollgroup } = usePollgroupContext();
  const client = useObservabilityPipelineHttpClient();

  const { setLastUpdated, isOnviewport, ...rest } = props;

  const { metrics, instances, poller } = usePoll({
    service: props.service,
    onChange: () => setLastUpdated(new Date()),
    onLoadingChange: setIsLoading
  });

  const service = useMemo(
    () => ({ ...props.service, metrics }),
    [props, metrics]
  );

  useEffect(() => {
    if (client) {
      poller.setAsyncFn(t => fetchMetrics(client, t, service.name));
      pollgroup.registerPollerIfNotExists(service.name, poller);
      pollgroup.setPollerPaused(service.name, !isOnviewport);
    }
  }, [client, isOnviewport, poller, pollgroup, service.name]);

  const selectedHost = instanceHost || instances || [];
  const instanceFilter = (
    <InstanceSelector
      instances={instances}
      selected={selectedHost}
      onChange={setInstanceHost}
    />
  );
  selectedHost["prefixId"] = null;

  return (
    <Service
      {...rest}
      service={service}
      hosts={selectedHost}
      actions={instanceFilter}
      isLoading={isLoading}
    />
  );
};

export default GridService;
